import { getColor } from '@volt_developers/foundations';

const INPUT_COLORS = {
    container: {
        border: {
            default: getColor("navy50"),
            error: getColor("red500"),
            active: getColor("blue500"),
        },
        background: {
            default: getColor("white"),
            disabled: getColor("navy10"),
        },
        body: {
            default: getColor("steel300"),
            active: getColor("steel500"),
        },
    },
    helpText: {
        default: getColor("steel400"),
        error: getColor("red500"),
        disabled: getColor("steel300"),
    },
    label: {
        default: getColor("steel500"),
        error: getColor("red500"),
    },
};
const INPUT_HEIGHT_MEDIUM = 36;
const INPUT_HEIGHT_LARGE = 48;

export { INPUT_COLORS, INPUT_HEIGHT_LARGE, INPUT_HEIGHT_MEDIUM };
//# sourceMappingURL=styles.js.map
